import { PermissionArrayType } from '../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../features/utils/utils.action';

export const ulareCentralStationPermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  READ: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin],
};
